import React, { ReactElement } from 'react';
import Modal from '@material-ui/core/Modal';
import makeStyles from '@material-ui/core/styles/makeStyles';
import ProductVto from 'components/UI/VTO/ProductVto';

type VtoModalProps = {
  glassesId: string | false;
  onClose: () => void;
  siteName: string;
};

export default function VtoModal({
  glassesId,
  onClose,
  siteName,
}: VtoModalProps): ReactElement | null {
  const classes = makeStyles({
    modal: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  })();

  if (!glassesId) return null;
  return (
    <Modal
      aria-labelledby="vto-title"
      aria-describedby="vto-description"
      open={!!glassesId}
      className={`${classes.modal} font-body`}
      onClose={onClose}
    >
      <div className="max-w-screen-lg">
        <ProductVto glassesId={glassesId} fullScreen onClose={onClose} siteName={siteName} />
      </div>
    </Modal>
  );
}
